import {
  MAX_CLIENT_SIDE_FORM_FIELDS,
  type FormField,
  type FormFieldType,
  type FormPresentation,
} from '@kanbu/schema/contracts';

export { MAX_CLIENT_SIDE_FORM_FIELDS };

export interface FormToolFormState {
  name: string;
  description: string;
  formTitle: string;
  formDescription: string;
  submitLabel: string;
  presentation: FormPresentation;
  disableDismiss: boolean;
  fields: FormField[];
  availableToAllChats: boolean;
  chatIds: string[];
  isActive: boolean;
}

export function slugifyFieldName(label: string): string {
  const slug = label
    .toLowerCase()
    .trim()
    .replaceAll(/[^\da-z]+/g, '_')
    .replaceAll(/^_+|_+$/g, '')
    .replace(/^(\d)/, 'field_$1');

  return (slug || 'field').slice(0, 60);
}

export function createEmptyField(partial?: Partial<FormField>): FormField {
  const label = partial?.label ?? '';

  return {
    name: partial?.name ?? (label ? slugifyFieldName(label) : 'field'),
    label,
    type: partial?.type ?? 'text',
    required: partial?.required ?? false,
    placeholder: partial?.placeholder,
    options: partial?.options,
    validation: partial?.validation,
  };
}

export function createEmptyFormState(
  partial?: Partial<FormToolFormState>,
): FormToolFormState {
  return {
    name: partial?.name ?? '',
    description: partial?.description ?? '',
    formTitle: partial?.formTitle ?? '',
    formDescription: partial?.formDescription ?? '',
    submitLabel: partial?.submitLabel ?? 'Submit',
    presentation: partial?.presentation ?? 'inline',
    disableDismiss: partial?.disableDismiss ?? false,
    fields: partial?.fields ?? [createEmptyField({ label: '', type: 'text' })],
    availableToAllChats: partial?.availableToAllChats ?? false,
    chatIds: partial?.chatIds ?? [],
    isActive: partial?.isActive ?? true,
  };
}

export function formStateToArtifact(form: FormToolFormState) {
  return {
    type: 'form' as const,
    title: form.formTitle || 'Form',
    description: form.formDescription || undefined,
    fields: form.fields.filter(field => field.label.trim()),
    submitLabel: form.submitLabel || 'Submit',
    presentation: form.presentation,
    disableDismiss: form.disableDismiss,
  };
}

export const FORM_FIELD_TYPES: FormFieldType[] = [
  'text',
  'email',
  'phone',
  'number',
  'date',
  'select',
  'textarea',
];
